var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
var SearchResultPipe = /** @class */ (function () {
    function SearchResultPipe() {
    }
    SearchResultPipe.prototype.transform = function (value) {
        var output = value.name + " - Level " + value.level;
        if (value.reference)
            output = value.reference + " - " + output;
        return output;
    };
    SearchResultPipe = __decorate([
        Pipe({ name: 'searchResult' })
    ], SearchResultPipe);
    return SearchResultPipe;
}());
export { SearchResultPipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLXJlc3VsdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNlYXJjaC1yZXN1bHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsT0FBTyxFQUFFLElBQUksRUFBaUIsTUFBTSxlQUFlLENBQUM7QUFJcEQ7SUFBQTtJQVNBLENBQUM7SUFSVSxvQ0FBUyxHQUFoQixVQUFpQixLQUFlO1FBQzVCLElBQUksTUFBTSxHQUFjLEtBQUssQ0FBQyxJQUFJLGlCQUFZLEtBQUssQ0FBQyxLQUFPLENBQUM7UUFFNUQsSUFBSSxLQUFLLENBQUMsU0FBUztZQUNmLE1BQU0sR0FBTSxLQUFLLENBQUMsU0FBUyxXQUFNLE1BQVEsQ0FBQztRQUU5QyxPQUFPLE1BQU0sQ0FBQztJQUNsQixDQUFDO0lBUlEsZ0JBQWdCO1FBRDVCLElBQUksQ0FBQyxFQUFFLElBQUksRUFBRSxjQUFjLEVBQUMsQ0FBQztPQUNqQixnQkFBZ0IsQ0FTNUI7SUFBRCx1QkFBQztDQUFBLEFBVEQsSUFTQztTQVRZLGdCQUFnQiJ9